export default __webpack_public_path__ + "static/media/abmalogo2.805c9b75.jpg";